import styled from 'styled-components'
import { AbstradexButton } from 'components/abstradex/components/ui'
import Link from 'next/link'

export const BuyVen = () => {
  return (
    <BuyVenSection>
      <div className="footer-top">
        <img src="/images/abstradex/svgs/footer-abs.svg" alt="" />
        {0.0075}
      </div>
      <Link passHref href="/swap">
        <AbstradexButton.AbstradexStyledActionButton as="a">Buy ABS</AbstradexButton.AbstradexStyledActionButton>
      </Link>
    </BuyVenSection>
  )
}

const BuyVenSection = styled.div`
  position: relative;
  height: ${({ theme }) => `${theme.abstradexValues.footerHeight}px`};
  background-color: rgba(13, 13, 15, 0.8);
  margin-top: auto;
  padding: 12px;

  display: flex;
  flex-direction: column;
  justify-content: space-around;

  &::after {
    content: '';
    position: absolute;

    background-image: url('/images/abstradex/svgs/why-choose-ellipse.svg');
    background-size: contain;
    width: 141.41px;
    height: 141.41px;

    bottom: 0;
    right: 0;
    transform: translate(25px, 50%);
  }

  .footer-top {
    display: flex;
    align-items: center;
    grid-gap: 8px;
    color: ${({ theme }) => `${theme.colors.absWhiteColor}`};
  }
`
